import { Component, Inject, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { EmbededComponent, ShareEmbedDialogData } from "../embeded/embeded.component";

@Component({
  selector: "app-embedforbundles",
  templateUrl: "../embeded/embeded.component.html",
  styleUrls: ["../embeded/embeded.component.scss"],
})
export class EmbedforbundlesComponent extends EmbededComponent {
  constructor(
    dialogRef: MatDialogRef<EmbededComponent>,
    dialog: MatDialog,
    toastr: ToastrService,
    sanitizer: DomSanitizer,
    @Optional() @Inject(MAT_DIALOG_DATA) dialogData?: ShareEmbedDialogData
  ) {
    super(dialogRef, dialog, toastr, sanitizer, {
      ...dialogData,
      contentType: "bundle",
      bundleData: dialogData?.bundleData || dialogData?.flowData,
    });
  }
}
